/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * wedofi
 * A RESTful API. 🔒 Protected endpoints require authentication via secure HTTP-only cookies. Authentication is handled automatically by Better Auth after login.
 * OpenAPI spec version: 1.0.47
 */

/**
 * [QA] Força a categoria do sinal (PESSIMO…OTIMO). Só no endpoint temporal. Sem este campo, consulta a API DCAI Combo 1 para a data do ciclo.
 */
export type ProcessDcaiCycleBodyDTOForceCategory = typeof ProcessDcaiCycleBodyDTOForceCategory[keyof typeof ProcessDcaiCycleBodyDTOForceCategory];


export const ProcessDcaiCycleBodyDTOForceCategory = {
  PESSIMO: 'PESSIMO',
  RUIM: 'RUIM',
  OK: 'OK',
  BOM: 'BOM',
  OTIMO: 'OTIMO',
} as const;
